var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggleShowNavDrawer}},[_c('icon',{attrs:{"icon":"bars"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }